import React, { Component } from 'react'
import Header from '../layout/Header';
import Banner from '../Common/Banner';
import DepartmentSidebar from './DepartmentSidebar';
import HodDisplay from './HodDisplay';
import NoData from "../Common/NoData";
import Loading from "../Common/Loading";
import ModalImage from "react-modal-image";
import { firestore } from '../../Config/FbConfig';
import { doc, getDoc } from 'firebase/firestore';


export default class Pharmacognosy extends Component {

    state = { Datas: [] }

    async componentDidMount() {
        //For Teaching
        const docRef = doc(firestore, "FacultiesandStaff", "Teaching");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            var Data = []
            Object.entries(docSnap.data()).forEach(([key, value]) => {
                if (value.Department === "Pharmacognosy") {
                    Data.push(Object.assign(
                        {
                            Id: key,
                            Priority: value.Priority != undefined ? value.Priority : "999",
                            Image: value.Image,
                            Name: value.Name,
                            Description: value.Description,
                            Designation: value.Designation,
                            Qualification: value.Qualification,
                            Link: value.Link
                        }))
                }
            });

            Data.length === 0 ? this.setState({ Datas: "NO_999" }) : this.setState({ Datas: Data.sort(function (a, b) { return a.Priority - b.Priority; }) })

        }

        else { this.setState({ Datas: "NO_999" }) }
    }

    render() {
        return (
            <div className="body_wrapper">
                <Header />
                <Banner title="Pharmacognosy" image="departments/Pharmacognosy.jpg" />

                {/* Content */}
                <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
                    <div className="container-xl">
                        <div className="row">
                            <div className="col-lg-9 content-area order-lg-2">
                                <div className="ttm-service-single-content-area">
                                    <div className="section-title with-desc text-left clearfix">
                                        <div className="title-header" style={{ borderTopColor: "red" }}>
                                            <h4 className="title">About Department</h4>
                                        </div>
                                    </div>
                                    <div className="ttm-service-description">
                                        <div className="row">
                                            <div className="col-md-5">
                                                <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/images/departments/department_4.jpg"} alt="Error" />
                                            </div>
                                            <div className="col-md-7" style={{ margin: "auto" }}>
                                                <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-15">
                                                    <li><i className="fa fa-arrow-circle-right ttm-textcolor-skincolor" />Credibility of the department is envisaged by changing departmental activities to meet the requirements of Herbal Drug Industry.</li>
                                                    <li><i className="fa fa-arrow-circle-right ttm-textcolor-skincolor" />Activity engaged in the study of drugs from natural origin.</li>
                                                    <li><i className="fa fa-arrow-circle-right ttm-textcolor-skincolor" />Research activities include Extraction, Isolation, characterization of herbal drugs.</li>
                                                </ul>
                                            </div>
                                            <div className="col-md-12 paddingtop-2">
                                                <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-15">
                                                    <li><i className="fa fa-arrow-circle-right ttm-textcolor-skincolor" />Biological studies of extracts and bio active molecule.</li>
                                                    <li><i className="fa fa-arrow-circle-right ttm-textcolor-skincolor" />Survey of Medicinal plants of western ghats, bioactive guided isolation, standardization of polyherbal formulations are the focused key areas of the department.</li>
                                                    <li><i className="fa fa-arrow-circle-right ttm-textcolor-skincolor" />Department is well equipped with the all the instruments for the research work.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <HodDisplay department="Pharmacognosy" />
                                    <div className="section-title with-desc text-left clearfix">
                                        <div className="title-header" style={{ borderTopColor: "red" }}>
                                            <h4 className="title">Our Teaching Faculty</h4>
                                        </div>
                                    </div>
                                    <div className="container">
                                        <div className="row paddingtop-1">
                                            {
                                                this.state.Datas.length === 0 ? <Loading /> :
                                                    this.state.Datas === "NO_999" ? <NoData /> :
                                                        this.state.Datas.map((data, i) => (
                                                            <div className="col-lg-6" key={i}>
                                                                <div className="row">
                                                                    <div className="col-lg-4">
                                                                        <div className="gallery-box">
                                                                            <ModalImage className="swaraimage1" small={data.Image} large={data.Image} alt="Image" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-8" style={{ margin: "auto" }}>
                                                                        <p style={{ color: "black", fontWeight: "bold" }}>{data.Name}</p>
                                                                        <p style={{ color: "black" }}>
                                                                            {data.Qualification}<br />
                                                                            {data.Designation}<br />
                                                                            <a href={data.Link} target="_blank">View Details</a>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <br />
                                                            </div>
                                                        ))
                                            }
                                        </div>
                                        <br />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 widget-area">
                                <DepartmentSidebar />
                            </div>
                        </div>
                    </div>
                </div>
                <br />
            </div>
        )
    }
}
